/**
 * Joins streamed assistant deltas into one message, starting the text that follows a tool
 * call on a new paragraph.
 *
 * The model's text before and after a tool call arrives as two separate runs of deltas with
 * nothing between them, so "…then generate a summary." + "I have the live contents." rendered
 * as one run-on sentence. The break is only inserted when neither side already ends or starts
 * with whitespace.
 */
export function createDeltaJoiner() {
  let lastChar = "";
  let breakPending = false;

  return {
    toolCalled(): void {
      breakPending = lastChar !== "";
    },
    next(delta: string): string {
      if (delta === "") return delta;
      const needsBreak = breakPending && !/\s/.test(lastChar) && !/^\s/.test(delta);
      breakPending = false;
      lastChar = delta.slice(-1);
      return needsBreak ? `\n\n${delta}` : delta;
    },
  };
}
